module.exports = __webpack_public_path__ + "img/noel-khumalo.bfff6bf6.png";